/* eslint react/forbid-prop-types: 0 */
/* eslint react/no-multi-comp: 0 */
/* eslint react/prefer-stateless-function: 0 */
/* eslint react/require-default-props: 0 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Glyphicon } from "react-bootstrap";
import DatePicker from "react-datepicker";

class WeekRange extends Component {
  render() {
    return (
      <Button onClick={this.props.onClick}>
        <Glyphicon glyph="calendar" />
      </Button>
    );
  }
}
WeekRange.propTypes = {
  onClick: PropTypes.func
};
class CalendarDatePicker extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleNextWeek = this.handleNextWeek.bind(this);
    this.handleLastWeek = this.handleLastWeek.bind(this);
  }

  handleChange(date) {
    this.props.onChange(date);
  }

  handleLastWeek() {
    this.props.onChange(this.props.date.subtract(7, "days"));
  }

  handleNextWeek() {
    this.props.onChange(this.props.date.add(7, "days"));
  }

  render() {
    const { date } = this.props;
    const from = date
      .clone()
      .startOf("week")
      .format("D MMM");
    const to = date
      .clone()
      .endOf("week")
      .format("D MMM, YYYY");

    const rangeDisplayStyle = {
      display: "inline-block",
      width: 155,
      textAlign: "center"
    };
    return (
      <div className="calendar-date-picker display-inline">
        <Button onClick={this.handleLastWeek}>
          <Glyphicon glyph="triangle-left" />
        </Button>
        <span style={rangeDisplayStyle}>{` ${from} - ${to} `}</span>
        <Button onClick={this.handleNextWeek}>
          <Glyphicon glyph="triangle-right" />
        </Button>

        <div className="date-wrapper">
          <DatePicker
            todayButton={"Today"}
            customInput={<WeekRange />}
            selected={date}
            onChange={this.handleChange}
          />
        </div>
      </div>
    );
  }
}

export default CalendarDatePicker;



// WEBPACK FOOTER //
// ./src/components/runsheets/list/CalendarDatePicker.js